import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { DebounceDirectiveModule } from 'src/app/angular-wallet-base/directives/debounce/debounce-directive.module';
import { Otc3Component } from './otc3.component';
import { MyOrdersComponent } from './my-orders/my-orders.component';
import { MarketOrdersComponent } from './market-orders/market-orders.component';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { TabsModule } from 'src/app/components/home-page/tabs/tabs.module';
import { HeaderModule } from 'src/app/components/header/header.module';

const routes: Routes = [
  {
    path: '',
    component: Otc3Component,
  },
];

@NgModule({
  declarations: [
    Otc3Component,
    MyOrdersComponent,
    MarketOrdersComponent,
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    IonicModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    DebounceDirectiveModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    // HeaderModule,
    TabsModule
  ]
})
export class Otc3Module { }
